import { render, staticRenderFns } from "./ChangelogList.vue?vue&type=template&id=57e1af15&scoped=true&"
import script from "./ChangelogList.vue?vue&type=script&lang=js&"
export * from "./ChangelogList.vue?vue&type=script&lang=js&"
import style0 from "./ChangelogList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ChangelogList.vue?vue&type=style&index=1&id=57e1af15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e1af15",
  null
  
)

export default component.exports